// Types
import type { useParams, usePathname } from 'next/navigation';

// Utils
import { formatUrls } from '@/utils/urls/formatUrl';

// lib
import { layoutHeaderDatepickerGlobalDisabled } from '@/lib/layout/layoutHeaderDatepickerGlobalDisabled';

type GetIsHeaderDatepickerGlobalDisabledProps = {
    pathname: ReturnType<typeof usePathname>;
    params: ReturnType<typeof useParams>;
};

export function getIsHeaderDatepickerGlobalDisabled({
    pathname,
    params
}: GetIsHeaderDatepickerGlobalDisabledProps) {
    const formattedUrls = formatUrls(layoutHeaderDatepickerGlobalDisabled, params);
    return formattedUrls.includes(pathname);
}
